module.exports = __webpack_public_path__ + "static/media/Happy-Birthday-2.15cbef0c.jpeg";